import script from "./SpecilalismsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpecilalismsPage.vue?vue&type=script&setup=true&lang=ts"

import "./SpecilalismsPage.vue?vue&type=style&index=0&id=7afe7dca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7afe7dca"]])

export default __exports__